import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var chooseImage = normalize.chooseImage(function (args) {
  return tt.chooseImage(args);
}, CONTAINER_NAME.BYTE);
export default chooseImage;